export const GENERATING_QUOTE_MESSAGE = 'Generating the quote. This may take up to 1 minute.';
